import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';

import Page from '../containers/Page';
import Header from '../components/main/header/Header';
import Footer from '../components/main/footer/Footer';
import ArticleContent from '../components/main/article/ArticleContent';

import ScrolledWrapper from '../components/main/article/ScrolledWrapper';
import MainWrapper from '../components/main/wrapper/MainWrapper';
import { getArtworkUrl } from '../components/main/utils/Contentful';

const Article = ({ content }) => {
  const { featuredImage, excerpt, title, gtmContainerId } = content;
  const imgUrl = getArtworkUrl(featuredImage);

  let ogImgUrl = null;
  if (imgUrl) {
    ogImgUrl = `${imgUrl}?fit=thumb&f=top_left&h=470&w=940`;
  }

  const metaTitle = `${title} | IDAGIO`;
  const metaData = {
    title: metaTitle,
    ogTitle: metaTitle,
    ogDescription: excerpt,
    ogImage: ogImgUrl,
  };
  return (
    <Page
      header={false}
      footer={false}
      metaData={metaData}
      showSmartBanner
      gtmContainerId={gtmContainerId}
    >
      <MainWrapper>
        <ScrolledWrapper>
          <Header />
          <ArticleContent content={content} />
          <Footer />
        </ScrolledWrapper>
      </MainWrapper>
    </Page>
  );
};

Article.propTypes = {
  content: PropTypes.object,
};

export default withRouteData(Article);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/pages/Article.js